import { render, staticRenderFns } from "./sectionChiefDecision.vue?vue&type=template&id=6e0d072f&scoped=true&"
import script from "./sectionChiefDecision.vue?vue&type=script&lang=js&"
export * from "./sectionChiefDecision.vue?vue&type=script&lang=js&"
import style0 from "./sectionChiefDecision.vue?vue&type=style&index=0&id=6e0d072f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0d072f",
  null
  
)

export default component.exports